import React from "react";

import Typography from "@/foundation/Typography/V2";

import { ActionButton } from "./style";

const BookmarkButton = ({
  isBookmarked,
  setIsBookmarked,
  count,
  height = 16,
  width = 16,
  iconMargin = "4px",
}) => {
  return (
    <ActionButton
      iconMargin={iconMargin}
      onClick={() => setIsBookmarked(!isBookmarked)}
    >
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={isBookmarked ? "active" : ""}
      >
        <path
          d="M11.4417 2.92495L12.9084 5.85828C13.1084 6.26662 13.6417 6.65828 14.0917 6.73328L16.75 7.17495C18.45 7.45828 18.85 8.69162 17.625 9.90828L15.5584 11.975C15.2084 12.325 15.0167 13 15.125 13.4833L15.7167 16.0416C16.1834 18.0666 15.1084 18.85 13.3167 17.7916L10.825 16.3166C10.375 16.05 9.63338 16.05 9.17505 16.3166L6.68338 17.7916C4.90005 18.85 3.81671 18.0583 4.28338 16.0416L4.87505 13.4833C4.98338 13 4.79171 12.325 4.44171 11.975L2.37505 9.90828C1.15838 8.69162 1.55005 7.45828 3.25005 7.17495L5.90838 6.73328C6.35005 6.65828 6.88338 6.26662 7.08338 5.85828L8.55005 2.92495C9.35005 1.33328 10.65 1.33328 11.4417 2.92495Z"
          stroke="#475467"
          strokeWidth="1.30374"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <Typography
        variant="label3"
        fontSize="14px"
        lineHeight="20px"
        fontFamily="var(--man-600)"
      >
        {count} Star{count > 1 ? `s` : ""}
      </Typography>
    </ActionButton>
  );
};

export default BookmarkButton;
